module.exports = __webpack_public_path__ + "img/bbasket.1969dbfc.png";